export class Unauthorized extends Error {
  constructor(message = 'unauthorized') {
    super(message)

    this.name = 'Unauthorized'
  }
}
